function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSending = function SvgSending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 24
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-861 -442)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(908 451)",
    style: {
      fill: "#7159cd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(956 451)",
    style: {
      fill: "#7159cd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1004 451)",
    style: {
      fill: "#7159cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0Z",
    style: {
      fill: "none"
    },
    transform: "translate(1039 442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2H3a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7a2.006 2.006 0 0 0 2-2V4a2.006 2.006 0 0 0-2-2Zm0 14H3V4h18Z",
    style: {
      fill: "#7159cd"
    },
    transform: "translate(1039 442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-8L8 0H2a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2V4a2.006 2.006 0 0 0-2-2Zm0 12H2V4h16Z",
    transform: "translate(861 446.563)",
    style: {
      fill: "#7159cd"
    }
  })));
};
export default SvgSending;